import * as React from 'react';
import { Link } from 'react-router-dom';

export default function Menu(props) { 
    const { width, height, fillcolor } = props;
  return (
<svg width={width || "22"} height={height || "17"}  viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M21.9999 1.21429C21.9999 0.543654 21.4562 0 20.7856 0H6.3907C5.72007 0 5.17642 0.543654 5.17642 1.21429C5.17642 1.88492 5.72007 2.42857 6.39071 2.42857H20.7856C21.4562 2.42857 21.9999 1.88492 21.9999 1.21429ZM0 8.5C0 7.82937 0.543655 7.28571 1.21429 7.28571H20.7856C21.4563 7.28571 21.9999 7.82937 21.9999 8.5C21.9999 9.17063 21.4563 9.71429 20.7856 9.71429H1.21429C0.543655 9.71429 0 9.17063 0 8.5ZM10.3528 15.7857C10.3528 15.1151 10.8965 14.5714 11.5671 14.5714H20.7856C21.4562 14.5714 21.9999 15.1151 21.9999 15.7857C21.9999 16.4564 21.4562 17 20.7856 17H11.5671C10.8965 17 10.3528 16.4564 10.3528 15.7857Z" fill={fillcolor|| "#114194"}/>
</svg>


  );
}